module.exports = new __parcel__URL__("insight-object-schema-list-body-skeleton.tpl.91afa82b.svg").toString();